import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button } from '@heroui/react';
import { DOCXIcon, PDFIcon } from '@components/drive/driveIcons';
import CustomizedDropdown from '@components/common/dropdowns/Dropdown';
import keyboardTypes from '@components/userDocuments/editDocument/editJournal/constants/keyboardTypes';
import breakpointsMinWidth from '@styling/breakpointsMinWidth';
import { FormatTypes } from '../../../../../../constants/templateDictionaries';
import { BrandeisBlue } from '../../../../../../styling/theme';
import docxSupportedTemplates from '../../../../../../utility/docxSupportedTemplates';
import getUserPlan from '../../getUserPlan';

const DownloadText = styled.span`
  font-size: 12px;
  font-weight: 500;
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;
const DownloadSpan = styled.span`
  color: ${BrandeisBlue};
  font-weight: 400;
`;

class Download extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: '',
    };
  }

  handleMouseEnter = () => {
    this.setState({ showDropdown: true });
  };

  handleMouseLeave = () => {
    this.setState({ showDropdown: false });
  };

  render() {
    const {
      upgradeMessage,
      formatType,
      text,
      childrenList,
      dropdownName,
      activePlan,
      subscriptionStatus,
      templateType,
      selectedPlan,
      universityPlan,
    } = this.props;

    const { showDropdown } = this.state;

    const itemsList = childrenList.map((item) => {
      if (item.text === 'PDF(.pdf)') {
        let disabled = false;
        if (
          getUserPlan(activePlan, subscriptionStatus, selectedPlan) === 'free'
        ) {
          if (formatType === FormatTypes.COVER_LETTER) {
            disabled = true;
          }
        }
        return {
          item: item.text,
          startIcon: <PDFIcon />,
          triggerFunction: item.triggerFunction,
          hasPopover: '',
          popoverData: undefined,
          isDisabled: disabled,
        };
      }
      if (item.text === 'MS Word(.docx)') {
        let docxEndContent;

        if (!universityPlan?.plan?.includes('Premium')) {
          docxEndContent = 'Premium';
        }

        let disabled = true;
        if (
          getUserPlan(activePlan, subscriptionStatus, selectedPlan) !== 'free'
        ) {
          if (
            docxSupportedTemplates[formatType.toLowerCase()] &&
            docxSupportedTemplates[formatType.toLowerCase()][
              templateType.toLowerCase()
            ]
          ) {
            disabled = false;
          } else {
            disabled = true;
          }
        } else {
          disabled = true;
        }
        return {
          item: item.text,
          startIcon: <DOCXIcon />,
          shortcut: docxEndContent,
          triggerFunction: item.triggerFunction,
          hasPopover: '',
          popoverData: undefined,
          isDisabled: disabled,
        };
      }
      return item;
    });

    return (
      <>
        <Button
          aria-label="Download document"
          size="sm"
          blockCursor={upgradeMessage}
          color="primary"
          variant="flat"
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <DownloadText>
            <DownloadSpan className={`text${dropdownName}`}>
              {text}
            </DownloadSpan>
          </DownloadText>
        </Button>
        <div
          role="button"
          tabIndex={0}
          onClick={this.handleMouseLeave}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onKeyDown={(e) => {
            if (e.key === keyboardTypes.ENTER || e.key === ' ') {
              this.handleMouseLeave();
            }
          }}
        >
          <CustomizedDropdown
            isOpen={showDropdown}
            top="38"
            left="-130"
            closeDropdown={() => this.setState({ showDropdown: false })}
            itemsList={itemsList}
            sectioned={false}
            styleClasses="w-[224px] text-left"
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { formatType } = ownProps;

  let templateType;
  let documentId;
  let noOfPages;
  let saveStatus;
  let usedSections;
  if (formatType === FormatTypes.RESUME) {
    ({ documentId } = state.editResumeFormReducer);
    ({ noOfPages } = state.editResumeFormReducer);
    ({ saveStatus } = state.editResumeFormReducer);
    usedSections = state.editResumeFormReducer.userPreferences.leftPane.used;
    templateType = state.editResumeFormReducer.resumeType;
  }
  if (formatType === FormatTypes.COVER_LETTER) {
    ({ documentId } = state.editCoverLetterFormReducer);
    ({ noOfPages } = state.editCoverLetterFormReducer);
    ({ saveStatus } = state.editCoverLetterFormReducer);
    templateType = state.editCoverLetterFormReducer.coverLetterType;
  }

  return {
    activePlan: state.userInfoReducer.activePlan,
    universityPlan: state.userInfoReducer.universityPlan,
    subscriptionStatus: state.userInfoReducer.subscriptionStatus,
    selectedPlan: state.userInfoReducer.selectedPlan,
    downloads: state.userInfoReducer.downloads,
    templateType,
    documentId,
    noOfPages,
    saveStatus,
    usedSections,
  };
};

export default connect(mapStateToProps)(Download);
